// One number format for ₪ amounts on every surface (screens, PDFs, emails):
// whole shekels with no decimals ("1,200"), and two decimals whenever there
// are agorot ("89.90", never "89.9").
/** The magnitude of `n`, formatted — the caller adds the ₪ and any minus. */
export function formatAmountAbs(n) {
    const abs = Math.abs(n);
    const hasAgorot = Math.round(abs * 100) % 100 !== 0;
    return abs.toLocaleString('he-IL', {
        minimumFractionDigits: hasAgorot ? 2 : 0,
        maximumFractionDigits: 2,
    });
}
//# sourceMappingURL=money.js.map